import React, { useState } from "react";
import { adminApi } from "../api/adminApi";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
} from "@material-ui/core";

export default function CreateUserModal({ open, onClose, onSaved }) {
    const [form, setForm] = useState({
        userName: "",
        email: "",
        password: "",
    });

    const [saving, setSaving] = useState(false);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSave = async () => {
        if (!form.userName || !form.email || !form.password) return;

        try {
            setSaving(true);
            await adminApi.createUser(form);
            onSaved && onSaved();
            onClose();
        } catch (err) {
            console.error(err);
            alert("Fehler beim Anlegen des Benutzers.");
        } finally {
            setSaving(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>Neuen Benutzer anlegen</DialogTitle>
            <DialogContent dividers>
                <TextField
                    margin="dense"
                    label="Benutzername"
                    name="userName"
                    fullWidth
                    value={form.userName}
                    onChange={handleChange}
                />
                <TextField
                    margin="dense"
                    label="E-Mail"
                    name="email"
                    type="email"
                    fullWidth
                    value={form.email}
                    onChange={handleChange}
                />
                <TextField
                    margin="dense"
                    label="Passwort"
                    name="password"
                    type="password"
                    fullWidth
                    value={form.password}
                    onChange={handleChange}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Abbrechen</Button>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={handleSave}
                    disabled={saving}
                >
                    {saving ? "Speichern..." : "Speichern"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
